import ErrorWithToast from "./ErrorWithToast";

class NeedsLogin extends ErrorWithToast{
  constructor() {
    super("Para fazer esta ação, você precisa estar Logado");
  }
}

export default NeedsLogin;